/* eslint-disable no-use-before-define */
/* eslint-disable react/prop-types */
import {
	Avatar,
	Box,
	Divider,
	Drawer,
	Hidden,
	Link,
	List,
	ListSubheader,
	makeStyles
} from '@material-ui/core';
import ReceiptIcon from '@material-ui/icons/ReceiptOutlined';
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import {
	Briefcase as BriefcaseIcon,
	Folder as FolderIcon,
	Map as MapIcon,
	PieChart as PieChartIcon,
	Share2 as ShareIcon,
	Terminal as TerminalIcon,
	Users as UsersIcon
} from 'react-feather';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { useSelector } from 'react-redux';
import { matchPath, useLocation } from 'react-router';
import { Link as RouterLink } from 'react-router-dom';
import Logo from 'src/components/Logo';
import userInfo from 'src/services/userInfo';
import NavItem from './NavItem';

const navConfig = [
	{
		subheader: 'Dashboards',
		items: [
			{
				title: 'Generale',
				acl: 'eportal.dashboard.general.menu',
				icon: PieChartIcon,
				href: '/app/reports/dashboard'
			}
		]
	},
	{
		subheader: 'Community',
		items: [
			{
				title: 'Comunità',
				href: '/app/communities',
				icon: ShareIcon
			},
			{
				title: 'Comunità aggregate',
				href: '/app/aggregates',
				icon: ShareIcon
			},
			{
				title: 'Contratti',
				href: '/app/contracts',
				icon: ReceiptIcon
			},
			{
				title: 'Clienti',
				href: '/app/customers',
				icon: UsersIcon
			},
			{
				title: 'Mappe',
				href: '/app/maps',
				icon: MapIcon
			},
			{
				title: 'Listini',
				href: '/app/management/priceLists',
				icon: ShareIcon
			}
		]
	},
	{
		subheader: 'Impostazioni',
		items: [
			{
				title: 'Sistema',
				// acl: 'eportal.menu.settings.system',
				icon: BriefcaseIcon,
				items: [
					{
						title: 'Accessi',
						icon: BriefcaseIcon,
						items: [
							{
								title: 'Utenti',
								// acl: 'commons.menu.usermanagement',
								href: '/app/system/users',
								icon: BriefcaseIcon
							},
							{
								title: 'Permessi',
								// acl: 'commons.menu.usermanagement',
								href: '/app/system/groups',
								icon: BriefcaseIcon
							}
						]
					},
					{
						title: 'Configurazione',
						icon: BriefcaseIcon,
						items: [
							{
								title: 'Tenants',
								// acl: 'commons.menu.tenant',
								href: '/app/system/tenants',
								icon: BriefcaseIcon
							},
							{
								title: 'Workspaces',
								// acl: 'commons.menu.workspace',
								href: '/app/system/workspaces',
								icon: BriefcaseIcon
							},
							{
								title: 'Tipologia workspace',
								// acl: 'commons.menu.workspace',
								href: '/app/system/workspacesType',
								icon: BriefcaseIcon
							},
							{
								title: 'Tipologia workflow',
								// acl: 'commons.menu.ticket',
								href: '/app/system/ticketType',
								icon: BriefcaseIcon
							},
							{
								title: 'Mailbox',
								// acl: 'commons.menu.mailbox',
								href: '/app/system/mailbox',
								icon: BriefcaseIcon
							}
						]
					},
					{
						title: 'Develop',
						icon: BriefcaseIcon,
						items: [
							{
								title: 'Storyboards',
								// acl: 'commons.menu.storyboard',
								href: '/app/system/storyboards',
								icon: BriefcaseIcon
							},
							{
								title: 'Migrazione storyboard',
								// acl: 'commons.menu.storyboard',
								href: '/app/system/migrations',
								icon: BriefcaseIcon
							}
						]
					},
					{
						title: 'Amministrazione',
						icon: BriefcaseIcon,
						items: [
							{
								title: 'Console Python',
								// acl: 'commons.menu.console',
								href: '/app/system/console',
								icon: TerminalIcon
							}
						]
					}
				]
			}
		]
	},
	{
		subheader: 'Supporto',
		href: '/app/pages',
		acl: 'eportal.menu.sa',
		items: [
			{
				title: 'Documenti',
				acl: 'commons.menu.file',
				href: '/app/documents',
				icon: FolderIcon
			}
		]
	}
];

function renderNavItems({ items, ...rest }) {
	return (
		<List disablePadding>
			{items.reduce(
				(acc, item) => reduceChildRoutes({ acc, item, ...rest }),
				[]
			)}
		</List>
	);
}

function reduceChildRoutes({ acc, pathname, item, depth = 0 }) {
	const key = item.title + depth;

	if (item.items) {
		let total = 0;
		for (let subitem of item.items) {
			if (userInfo.can(subitem.acl)) {
				total++;
			}
		}

		if (total > 0) {
			const open = matchPath(pathname, {
				path: item.href,
				exact: false
			});

			if (userInfo.can(item.acl)) {
				acc.push(
					<NavItem
						depth={depth}
						icon={item.icon}
						key={key}
						info={item.info}
						open={Boolean(open)}
						title={item.title}
					>
						{renderNavItems({
							depth: depth + 1,
							pathname,
							items: item.items
						})}
					</NavItem>
				);
			}
		}
	} else {
		if (userInfo.can(item.acl)) {
			acc.push(
				<NavItem
					depth={depth}
					href={item.href}
					icon={item.icon}
					key={key}
					info={item.info}
					title={item.title}
				/>
			);
		}
	}

	return acc;
}

const useStyles = makeStyles(() => ({
	mobileDrawer: {
		width: 256
	},
	desktopDrawer: {
		width: 256,
		top: 64,
		height: 'calc(100% - 64px)'
	},
	avatar: {
		cursor: 'pointer',
		width: 64,
		height: 64
	}
}));

function NavBar({ openMobile, onMobileClose }) {
	const classes = useStyles();
	const location = useLocation();
	const { user } = useSelector(state => state.account);

	useEffect(() => {
		if (openMobile && onMobileClose) {
			onMobileClose();
		}
		// eslint-disable-next-line
	}, [location.pathname]);

	const content = (
		<Box height="100%" display="flex" flexDirection="column">
			<PerfectScrollbar options={{ suppressScrollX: true }}>
				<Hidden lgUp>
					<Box p={2} display="flex" justifyContent="center">
						<RouterLink to="/">
							<Logo />
						</RouterLink>
					</Box>
				</Hidden>
				<Box p={2}>
					<Box display="flex" justifyContent="center">
						<RouterLink to="/app/account">
							<Avatar alt="User" className={classes.avatar} src={user.avatar} />
						</RouterLink>
					</Box>
					<Box mt={2} textAlign="center">
						<Link
							component={RouterLink}
							to="/app/account"
							variant="h5"
							color="textPrimary"
							underline="none"
						>
							{`${user.firstName} ${user.lastName}`}
						</Link>
					</Box>
				</Box>
				<Divider />
				<Box p={2}>
					{navConfig.map(config => (
						<List
							key={config.subheader}
							subheader={
								<ListSubheader disableGutters disableSticky>
									{config.subheader}
								</ListSubheader>
							}
						>
							{renderNavItems({
								items: config.items,
								pathname: location.pathname
							})}
						</List>
					))}
				</Box>
			</PerfectScrollbar>
		</Box>
	);

	return (
		<>
			<Hidden lgUp>
				<Drawer
					anchor="left"
					classes={{ paper: classes.mobileDrawer }}
					onClose={onMobileClose}
					open={openMobile}
					variant="temporary"
				>
					{content}
				</Drawer>
			</Hidden>
			<Hidden mdDown>
				<Drawer
					anchor="left"
					classes={{ paper: classes.desktopDrawer }}
					open
					variant="persistent"
				>
					{content}
				</Drawer>
			</Hidden>
		</>
	);
}

NavBar.propTypes = {
	onMobileClose: PropTypes.func,
	openMobile: PropTypes.bool
};

export default NavBar;
